import styled from 'styled-components';

export const CompanyLink = styled.a`
    text-decoration: none !important;
    &:hover {
        color: rgba(0, 0, 0, 0.6);
    }
`;
